import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
//import '../../../assets/css/siicex-usuario.css';


import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
// import {OPTIONS_ACTIVE} from '../../../constants';
// import Error from '../../Error/error';

import {DropDownList} from '../../Elements/Select/dropdown';
// import {DropDownListChild} from '../../Elements/Select/dropdown';

const user = JSON.parse(localStorage.getItem("user"));

export default class AddSector extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            loading : false,
            add: false
          }
    
        this.handleInputChange = this.handleInputChange.bind(this);
      }
    
    
      handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
          
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[target.name] = value;
            
        this.setState({
            resource: copyResource
        });
    }

    componentDidMount(){
        var key = 0;
        const url = `${API_URL}SectorUX/${key}`;
        
        axios.get(url).then(response => response.data)
        .then((data) => {
            console.log(data);
            this.setState({ resource: data.result, response: data, error: data.Error });
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log(error);
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error("¡Error al inicializar!");
        });
    }

    

     handleClickCancel(e) {
        const {history: {push}} = this.props;    
        push('/sector');
     }

     callFunctionButton = (event) => {

        this.setState({loading:true});

        

        const {history: {push}} = this.props;    
        const url = `${API_URL}SectorUX/`;

        const formData = JSON.stringify(this.state.resource);

        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {             
                    console.log(data);
                    
                    if (data.data.isSucess)
                    {
                        toast.success('Recurso registrado correctamente. \n Se redireccionará al listado');
                        setTimeout(() => { push('/sector');}, 1000);  
                    } else 
                    {
                        toast.error('Error en el registro');
                        this.setState({loading:false});
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado');
                this.setState({loading:false});
            }); 
     }



    render() {

        return ( 
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div> 
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >

                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioCreacion" name="nUsuarioCreacion" defaultValue={user.nUsuario} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={0} />
                            
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                         <div className="row ">
                                            <div className="col-md-5 ">
                                                <div className="boletin__filters section__margin-bottom">
                                                    <div className="form-group">
                                                        <label htmlFor="nSectorCodigo"><strong>Código</strong></label>
                                                        <input type="text" readOnly name="nSectorCodigo" defaultValue={0} onChange={this.handleInputChange} id="nSectorCodigo" className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="sDescripcion"><strong>Descripción</strong></label>
                                                        <input type="text" name="sDescripcion" id="sDescripcion" onChange={this.handleInputChange} defaultValue={this.state.resource.sDescripcion} className="form-control text-filter__form-control" placeholder="Descripción" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="sClave"><strong>Clave</strong></label>
                                                        <input type="text" name="sClave" id="sClave" onChange={this.handleInputChange} defaultValue={this.state.resource.sClave} className="form-control text-filter__form-control" placeholder="Clave" />
                                                    </div>                                                     
                                                    <div className="form-group">
                                                        <label htmlFor="bActivo"><strong>Activo</strong></label>
                                                        <div className="">
                                                            <DropDownList name="bActivo"  onChange={this.handleInputChange} clave={true} id="bActivo" componente={"Activo"} />
                                                        </div>
                                                    </div> 
                                                </div>                                     
                                            </div>
                                            <div className="col-md-7 ">
                                                <div className="">
                                                    <strong><hr/></strong>
                                                    <strong>FECHA DE CREACIÓN:</strong>
                                                    <br/> 
                                                    <strong>CREADO POR</strong> : MIGUEL QUIROZ 
                                                    <br/><br/>
                                                    <strong>FECHA DE MODIFICACIÓN:</strong> 
                                                    <br/> 
                                                    <strong>MODIFICADO POR:</strong> MIGUEL QUIROZ

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button> 
                                                &nbsp;
                                                <ButtonLoader text="GUARDAR" textProcessing="PROCESANDO..." loading={this.state.loading} callFunctionButton={() => this.callFunctionButton()}></ButtonLoader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>    
                );
    }
}
